import { render, staticRenderFns } from "./dongwonDetail.vue?vue&type=template&id=6a2093e8&scoped=true"
import script from "./dongwonDetail.vue?vue&type=script&lang=js"
export * from "./dongwonDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2093e8",
  null
  
)

export default component.exports